module.exports = __webpack_public_path__ + "media/images/icons/icon_cross-3121ad51445e0ad6ec60b75a11893a78.svg";